export default "assets/images/icons/wine-cepages-8fc790b5.svg";